<div class="form-group mb-0">
  <select class="custom-select" [formControl]="filterDateForm">
    <option selected value="12months">Últimos 12 meses</option>
    <option value="24months">Últimos 24 meses</option>
    <option value="all">Todo</option>
  </select>
</div>
